module.exports = "https://cdn.hellotech.com/client-assets/home-checkup_41a3d480b38d8f934a790c8e922ade7e.svg";